import { CryptoInterstitial } from './CryptoInterstitial'

export { useCrypto, CRYPTO_GRADIENT, CRYPTO_SYMBOL } from './useCrypto'

export default CryptoInterstitial
